import { IoMdClose, IoMdColorFill } from 'react-icons/io';
import { useEffect, useState, useRef } from 'react';
import styled, { keyframes, css } from 'styled-components';
import LS from '../styles/layoutStyled';
import { useRecoilState } from 'recoil';
import { errorMsgRecoil, confirmMsgRecoil } from '../atom/ModalAtom';

const ToastingModal = () => {
  const [errorMsg, setErrorMsg] = useRecoilState(errorMsgRecoil);
  const [confirmMsg, setConfirmMsg] = useRecoilState(confirmMsgRecoil);
  const [isEmVisible, setIsEmVisible] = useState(false);
  const [isCfVisible, setIsCfVisible] = useState(false);

  const errorRef = useRef<HTMLDivElement>(null);
  const confirmRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (errorMsg) {
      setIsEmVisible(true);

      const timer = setTimeout(() => {
        setIsEmVisible(false);
        setTimeout(() => {
          setErrorMsg(null);
        }, 500);
      }, 2000);

      if (errorRef.current) errorRef.current.style.zIndex = '12';
      if (confirmRef.current) confirmRef.current.style.zIndex = '11';

      return () => clearTimeout(timer);
    }
  }, [errorMsg]);

  useEffect(() => {
    if (confirmMsg) {
      setIsCfVisible(true);

      const timer = setTimeout(() => {
        setIsCfVisible(false);
        setTimeout(() => {
          setConfirmMsg(null);
        }, 500);
      }, 2000);

      if (errorRef.current) errorRef.current.style.zIndex = '11';
      if (confirmRef.current) confirmRef.current.style.zIndex = '12';

      return () => clearTimeout(timer);
    }
  }, [confirmMsg]);

  return (
    <>
      {isEmVisible && errorMsg !== null && (
        <Box
          $isEmVisible={isEmVisible}
          $isCfVisible={false}
          className="error-modal"
          ref={errorRef}
        >
          <p>{errorMsg}</p>
        </Box>
      )}

      {isCfVisible && confirmMsg !== null && (
        <Box
          $isEmVisible={false}
          $isCfVisible={isCfVisible}
          className="confirm-modal"
          ref={confirmRef}
        >
          <p>{confirmMsg}</p>
        </Box>
      )}
    </>
  );
};

export default ToastingModal;

const fadeEffect = keyframes`
    0% {
        opacity: 0;
        bottom: -100px;
        visibility: hidden;
    }
    25% {
        opacity: 1;
        bottom: 20px;
        visibility: visible;
    }
    80% {
        opacity: 1;
        bottom: 20px;
        visibility: visible;
    }
    100% {
        opacity: 0;
        bottom: 20px;
        visibility: hidden;
    }
`;

const Box = styled.div<{ $isEmVisible?: boolean; $isCfVisible?: boolean }>`
  width: calc(100% - 40px);
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  padding: 16px;
  border-radius: 4px;
  display: flex;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.15);
  bottom: 20px;
  opacity: 0;
  visibility: hidden;
  z-index: 11;
  &.error-modal {
    background-color: #ffe4e4;
    animation: ${({ $isEmVisible }) => ($isEmVisible ? fadeEffect : '')} 2s
      forwards;

    > p {
      color: #dd6868;
    }
  }
  &.confirm-modal {
    background-color: #f2ffdd;
    animation: ${({ $isCfVisible }) => ($isCfVisible ? fadeEffect : '')} 2s
      forwards;

    > p {
      color: #169022;
    }
  }

  > p {
    width: 100%;
    font-size: 14px;
    line-height: 140%;
    white-space: pre-wrap;
  }
`;
